import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  DropdownTreeSelect,
  Spinner,
  ReactTags,
  Common,
  DatePickerComponent
} from '../../config/react'
import 'react-tag-autocomplete/example/src/styles.css'
const AddCoupons = () => {
  const urlParams = useParams()
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  // const validator = useRef(
  //   new SimpleReactValidator({
  //     validators: {
  //       alphanumeric: {
  //         // Custom validator name
  //         message: 'The :attribute field is required',
  //         rule: (val) => Inputs.amount_type === 'amount',
  //         required: true
  //       }
  //     }
  //   })
  // )
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [Categories, setCategories] = useState([])
  const [ExcludeCategories, setExcludeCategories] = useState([])
  const [SelectedCategoryIds, setSelectedCategoryIds] = useState([])
  const [SelectedExcludeCategoryIds, setSelectedExcludeCategoryIds] = useState([])
  const [Products, setProducts] = useState([])
  const [ProductTags, setProductTags] = useState([])
  const [ExcludeProductTags, setExcludeProductTags] = useState([])
  const [CustomerTags, setCustomerTags] = useState([])
  const [ExcludeProducts, setExcludeProducts] = useState([])
  const [SelectedProductsIds, setSelectedProductsIds] = useState([])
  const [SelectedExcludeProductsIds, setSelectedExcludeProductsIds] = useState([])
  const [Customers, setCustomers] = useState([])
  const [SelectedCustomerIds, setSelectedCustomerIds] = useState([])
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [Inputs, setInputs] = useState({
    id: 0,
    coupon_code: '',
    description: '',
    discount_type: 'fixed_cart_discount',
    amount_type: 'percentage',
    coupon_amount: '',
    coupon_percentage: '',
    coupon_expiry: '',
    minimum_spend: '',
    maximum_spend: '',
    usage_coupon: '',
    usage_limit_item: '',
    usage_limit_user: 1,
    status: 0
  })

  useEffect(() => {
    setIsAuth(true)
    setLoading(false)
    document.title = Title.AddCoupons
    if (urlParams.id !== undefined) {
      document.title = Title.EditCoupons
      GetCouponDetail()
    }
    GetCategories()
  }, [urlParams.id])

  const GetCouponDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetCouponDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0][0]
        const responseData = {
          id: data.id,
          coupon_code: data.coupon_code,
          description: data.description,
          discount_type: data.discount_type,
          coupon_amount: data.coupon_amount,
          coupon_percentage: data.coupon_percentage,
          amount_type:
            data.coupon_amount !== 0 && data.coupon_amount !== null ? 'amount' : 'percentage',
          coupon_expiry: data.expire_date,
          minimum_spend: data.minimum_spend,
          maximum_spend: data.maximum_spend,
          usage_coupon: data.used_per_coupon,
          usage_limit_item: data.limit_cart_products,
          usage_limit_user: data.used_per_user,
          status: data.status
        }
        if (responseData.coupon_expiry !== '') {
          const date = new Date(responseData.coupon_expiry).toISOString().split('T')[0]
          responseData.coupon_expiry = date
        }

        setInputs(responseData)
        setSelectedProductsIds(
          data.product_ids !== null && data.product_ids.length > 0
            ? Common.GetJSON(data.product_ids)
            : []
        )
        setProductTags(
          data.product_ids !== null && data.product_ids.length > 0 ? data.products : []
        )
        setSelectedExcludeProductsIds(
          data.exclude_product_ids !== null && data.exclude_product_ids.length > 0
            ? Common.GetJSON(data.exclude_product_ids)
            : []
        )
        setExcludeProductTags(
          data.exclude_product_ids !== null && data.exclude_product_ids.length > 0
            ? data.exclude_products
            : []
        )
        setSelectedCustomerIds(
          data.user_ids !== null && data.user_ids.length > 0 ? Common.GetJSON(data.user_ids) : []
        )
        GetCategories(data.category_ids)
        setCustomerTags(data.user_ids !== null && data.user_ids.length > 0 ? data.customers : [])
        setForceUpdate(!isForceUpdate)
      }
    })
  }
  const GetCategories = (selectedCategory = null, selectedExcludeCategory = null) => {
    setLoading(true)
    HttpService.postApi(API.GetCategory, null).then((response) => {
      setLoading(false)
      if (response.data.result) {
        response.data.result[0] = response.data.result[0].filter((item) => item.status === 1)
        // filter parent category
        const parentCategories = response.data.result[0].filter(
          (x) => x.parent_id === 1 && x.is_diamond_category === 0
        )
        const categories = []
        const excludeCategories = []
        parentCategories.map((item) => {
          // filter sub categories by parent
          const filteredSubcategories = response.data.result[0].filter(
            (x) => x.parent_id === item.id && x.is_diamond_category === 0
          )
          const subcategories = []
          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id && x.is_diamond_category === 0
            )
            const subchildcategories = []
            filteredSubChildCategories.map((childitem) => {
              subchildcategories.push({
                label: childitem.name,
                value: childitem.id,
                checked: false,
                children: []
              })
              return true
            })
            subcategories.push({
              label: subitem.name,
              value: subitem.id,
              checked: false,
              children: subchildcategories
            })
            return true
          })
          const subcategories1 = []
          filteredSubcategories.map((subitem) => {
            // filter sub child categories by parent
            const filteredSubChildCategories = response.data.result[0].filter(
              (x) => x.parent_id === subitem.id && x.is_diamond_category === 0
            )
            const subchildcategories1 = []
            filteredSubChildCategories.map((childitem) => {
              subchildcategories1.push({
                label: childitem.name,
                value: childitem.id,
                checked: false,
                children: []
              })
              return true
            })
            subcategories1.push({
              label: subitem.name,
              value: subitem.id,
              checked: false,
              children: subchildcategories1
            })
            return true
          })
          categories.push({
            label: item.name,
            value: item.id,
            children: subcategories,
            checked: false
          })
          excludeCategories.push({
            label: item.name,
            value: item.id,
            children: subcategories1,
            checked: false
          })
          return true
        })
        if (selectedCategory !== null) {
          for (var i = 0; i < categories.length; i++) {
            selectedCategory.map((cate) => {
              if (cate === categories[i].value) {
                categories[i].checked = true
              }
              return true
            })
            var children = categories[i].children
            if (children.length > 0) {
              for (var j = 0; j < children.length; j++) {
                selectedCategory.map((cate1) => {
                  if (cate1 === children[j].value) {
                    children[j].checked = true
                  }
                  return true
                })
                var children1 = children[j].children
                if (children1.length > 0) {
                  for (var k = 0; k < children1.length; k++) {
                    selectedCategory.map((cate2) => {
                      if (cate2 === children1[k].value) {
                        children1[k].checked = true
                      }
                      return true
                    })
                  }
                }
              }
            }
          }
        }
        setCategories(categories)
        if (selectedExcludeCategory !== null) {
          for (i = 0; i < categories.length; i++) {
            selectedExcludeCategory.map((cate) => {
              if (cate === excludeCategories[i].value) {
                excludeCategories[i].checked = true
              }
              return true
            })
            children = excludeCategories[i].children
            if (children.length > 0) {
              for (j = 0; j < children.length; j++) {
                selectedExcludeCategory.map((cate1) => {
                  if (cate1 === children[j].value) {
                    children[j].checked = true
                  }
                  return true
                })
                children1 = children[j].children
                if (children1.length > 0) {
                  for (k = 0; k < children1.length; k++) {
                    selectedExcludeCategory.map((cate2) => {
                      if (cate2 === children1[k].value) {
                        children1[k].checked = true
                      }
                      return true
                    })
                  }
                }
              }
            }
          }
        }
        setExcludeCategories(excludeCategories)
      }
    })
  }
  const onChangeCategory = (currentNode, selectedNodes) => {
    const array = []
    if (selectedNodes.length > 0) {
      for (let i = 0; i < selectedNodes.length; i++) {
        array.push(selectedNodes[i].value)
      }
    }
    setSelectedCategoryIds(array)
    setForceUpdate(!isForceUpdate)
    Categories.map((item, index) => {
      if (array.indexOf(item.value) >= 0) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      item.children.map((subitem, subindex) => {
        if (array.indexOf(subitem.value) >= 0) {
          Categories[index].children[subindex].checked = true
        } else {
          Categories[index].children[subindex].checked = false
        }
        subitem.children.map((subitem1, subindex1) => {
          if (array.indexOf(subitem1.value) >= 0) {
            Categories[index].children[subindex].children[subindex1].checked = true
          } else {
            Categories[index].children[subindex].children[subindex1].checked = false
          }
          return true
        })
        return true
      })
      return true
    })
  }
  const onChangeExcludeCategory = (currentNode, selectedNodes) => {
    const array = []
    if (selectedNodes.length > 0) {
      for (let i = 0; i < selectedNodes.length; i++) {
        array.push(selectedNodes[i].value)
      }
    }
    setSelectedExcludeCategoryIds(array)
    setForceUpdate(!isForceUpdate)
    ExcludeCategories.map((item, index) => {
      if (array.indexOf(item.value) >= 0) {
        ExcludeCategories[index].checked = true
      } else {
        ExcludeCategories[index].checked = false
      }
      item.children.map((subitem, subindex) => {
        if (array.indexOf(subitem.value) >= 0) {
          ExcludeCategories[index].children[subindex].checked = true
        } else {
          ExcludeCategories[index].children[subindex].checked = false
        }
        subitem.children.map((subitem1, subindex1) => {
          if (array.indexOf(subitem1.value) >= 0) {
            ExcludeCategories[index].children[subindex].children[subindex1].checked = true
          } else {
            ExcludeCategories[index].children[subindex].children[subindex1].checked = false
          }
          return true
        })
        return true
      })
      return true
    })
  }
  const onChangeProduct = (value) => {
    if (value.trim().length < 3) return setProducts()
    new Promise((resolve) => {
      const param = {
        term: value
      }
      HttpService.postApi(API.SearchProducts, param).then((response) => {
        let products = []
        if (response.data.result.length > 0) {
          products = response.data.result.map((item) => ({
            value: item.id,
            label: item.name + ' - ' + item.sku
          }))
        } else products = []
        setProducts(products)
        setForceUpdate(!isForceUpdate)
        resolve(products)
      })
    })
  }
  const onChangeExcludeProduct = (value) => {
    if (value.trim().length < 3) return setExcludeProducts()
    new Promise((resolve) => {
      const param = {
        term: value
      }
      HttpService.postApi(API.SearchProducts, param).then((response) => {
        let products = []
        if (response.data.result.length > 0) {
          products = response.data.result.map((item) => ({
            value: item.id,
            label: item.name + ' - ' + item.sku
          }))
        } else products = []
        setExcludeProducts(products)
        setForceUpdate(!isForceUpdate)
        resolve(products)
      })
    })
  }
  const onChangeCustomer = (value) => {
    if (value.trim().length < 3) return setCustomers()
    new Promise((resolve) => {
      const param = {
        name: value,
        // email: value,
        customergroup: ''
      }
      HttpService.postApi(API.GetCustomerList, param).then((response) => {
        let customers = []
        if (response.data.result.length > 0) {
          customers = response.data.result.map((item) => ({
            value: item.id,
            label: item.firstname + ' ' + item.lastname
          }))
        } else {
          customers = []
          setCustomers()
        }
        setCustomers(customers)
        setForceUpdate(!isForceUpdate)
        resolve(customers)
      })
    })
  }

  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value
    if (field === 'status') {
      setInputs({ ...Inputs, [field]: e.target.checked })
    } else {
      setInputs({ ...Inputs, [field]: fieldval })
    }

    if (field === 'percentage') {
      validator.current.hideMessageFor('coupon_amount')
    } else if (field === 'amount') {
      validator.current.hideMessageFor('coupon_percentage')
    }
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (Inputs.discount_type !== 'fixed_cart_discount') {
      validator.current.errorMessages.maximum_spend = null
      validator.current.errorMessages.minimum_spend = null
      validator.current.fields.maximum_spend = true
      validator.current.fields.minimum_spend = true
    }
    if (Inputs.amount_type !== 'percentage') {
      validator.current.errorMessages.coupon_percentage = null
      validator.current.fields.coupon_percentage = true
    }
    if (Inputs.amount_type !== 'amount') {
      validator.current.errorMessages.coupon_amount = null
      validator.current.fields.coupon_amount = true
    }
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    const param = {
      id: Inputs.id,
      coupon_code: Inputs.coupon_code.trim(),
      description: Inputs.description,
      discount_type: Inputs.discount_type,
      coupon_amount:
        Inputs.amount_type !== 'amount'
          ? 0
          : Inputs.coupon_amount === ''
            ? 0
            : parseInt(Inputs.coupon_amount),
      coupon_percentage:
        Inputs.amount_type !== 'percentage'
          ? 0
          : Inputs.coupon_percentage === ''
            ? 0
            : parseInt(Inputs.coupon_percentage),
      coupon_expiry: Inputs.coupon_expiry,
      minimum_spend: Inputs.minimum_spend === '' ? 0 : parseInt(Inputs.minimum_spend),
      maximum_spend: Inputs.maximum_spend === '' ? 0 : parseInt(Inputs.maximum_spend),
      usage_coupon: Inputs.usage_coupon !== '' ? parseInt(Inputs.usage_coupon) : 0,
      usage_limit_item: Inputs.usage_limit_item !== '' ? parseInt(Inputs.usage_limit_item) : 0,
      usage_limit_user: Inputs.usage_limit_user !== '' ? parseInt(Inputs.usage_limit_user) : 0,
      category_ids:
        (SelectedProductsIds !== null && SelectedProductsIds.length > 0) ||
        (SelectedExcludeProductsIds !== null && SelectedExcludeProductsIds.length > 0)
          ? '[]'
          : JSON.stringify(SelectedCategoryIds),
      exclude_category_ids:
        (SelectedProductsIds !== null && SelectedProductsIds.length > 0) ||
        (SelectedExcludeProductsIds !== null && SelectedExcludeProductsIds.length > 0)
          ? '[]'
          : JSON.stringify(SelectedExcludeCategoryIds),
      product_ids:
        (SelectedCategoryIds !== null && SelectedCategoryIds.length > 0) ||
        (SelectedExcludeCategoryIds !== null && SelectedExcludeCategoryIds.length > 0)
          ? '[]'
          : JSON.stringify(SelectedProductsIds),
      exclude_product_ids:
        (SelectedCategoryIds !== null && SelectedCategoryIds.length > 0) ||
        (SelectedExcludeCategoryIds !== null && SelectedExcludeCategoryIds.length > 0)
          ? '[]'
          : JSON.stringify(SelectedExcludeProductsIds),
      customer_ids: JSON.stringify(SelectedCustomerIds),
      status: Inputs.status ? 1 : 0,
      Userid: user.id
    }

    // if (Inputs.amount_type === 'percentage') {
    //   param.coupon_amount = 0
    // } else {
    //   param.coupon_percentage = 0
    // }

    if (urlParams.id !== undefined && urlParams.id !== null) {
      setLoading(true)
      HttpService.postApi(API.UpdateCoupon, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordUpdated)
        setForceUpdate(!isForceUpdate)
        history.push('/coupons')
      })
    } else {
      setLoading(true)
      HttpService.postApi(API.AddCoupon, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordAdded)
        setForceUpdate(!isForceUpdate)
        history.push('/coupons')
      })
    }
  }
  const onDeleteProduct = (i) => {
    const newTags = ProductTags.slice(0)
    newTags.splice(i, 1)
    setProductTags(newTags)
    setSelectedProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onDeleteExcludeProduct = (i) => {
    const newTags = ExcludeProductTags.slice(0)
    newTags.splice(i, 1)
    setExcludeProductTags(newTags)
    setSelectedExcludeProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onDeleteCustomer = (i) => {
    const newTags = CustomerTags.slice(0)
    newTags.splice(i, 1)
    setCustomerTags(newTags)
    setSelectedCustomerIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }

  const onSelectProduct = (tag) => {
    const newTags = [...ProductTags, tag]
    setProductTags(newTags)
    setSelectedProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onSelectExcludeProduct = (tag) => {
    const newTags = [...ExcludeProductTags, tag]
    setExcludeProductTags(newTags)
    setSelectedExcludeProductsIds(newTags.map((item) => item.value))
    setForceUpdate(!isForceUpdate)
  }
  const onSelectCustomer = (tag) => {
    const newTags = [...CustomerTags, tag]
    setCustomerTags(newTags)
    setSelectedCustomerIds(newTags.map((item) => item.value))
    setCustomers()
    setForceUpdate(!isForceUpdate)
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditCoupons : Title.AddCoupons}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Coupon Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="coupon_code"
                        onChange={handleInputChanges}
                        value={Inputs.coupon_code}
                        placeholder="Coupon Code"
                      />
                      {validator.current.message(
                        'Coupon Code',
                        Inputs.coupon_code,
                        'required|alpha_num_dash|max:255',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        onChange={handleInputChanges}
                        value={Inputs.description}
                        placeholder="Description"
                        rows="2"
                      ></textarea>
                      {validator.current.message('Description', Inputs.description, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Discount Type</label>
                      <select
                        className="form-control"
                        name="discount_type"
                        onChange={handleInputChanges}
                        value={Inputs.discount_type}
                        disabled
                      >
                        <option value="fixed_cart_discount">Fixed Cart Discount</option>
                        <option value="fixed_product_discount">Fixed Product Discount</option>
                      </select>
                      {validator.current.message(
                        'Discount Type',
                        Inputs.discount_type,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Coupon Amount</label>
                      <div className="row">
                        <div className="col-md-3">
                          <select
                            className="form-control"
                            name="amount_type"
                            value={Inputs.amount_type}
                            onChange={handleInputChanges}
                          >
                            <option value="percentage">%</option>
                            <option value="amount">Amount</option>
                          </select>
                        </div>
                        {Inputs.amount_type === 'percentage' && (
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control"
                              name="coupon_percentage"
                              onChange={handleInputChanges}
                              value={Inputs.coupon_percentage}
                              placeholder="Coupon Percentage"
                              onWheel={(e) => e.currentTarget.blur()}
                            />
                            {validator.current.message(
                              'coupon_percentage',
                              Inputs.coupon_percentage,
                              Inputs.amount_type !== 'amount'
                                ? 'required|numeric|max:99,num|min:0,num'
                                : '',
                              { className: 'error' }
                            )}
                          </div>
                        )}
                        {Inputs.amount_type === 'amount' && (
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control"
                              name="coupon_amount"
                              onChange={handleInputChanges}
                              value={Inputs.coupon_amount}
                              placeholder="Coupon Amount"
                              onWheel={(e) => e.currentTarget.blur()}
                              min="0"
                            />
                            {validator.current.message(
                              'coupon_amount',
                              Inputs.coupon_amount,
                              Inputs.amount_type !== 'percentage'
                                ? 'required|numeric|min:0,num'
                                : '',
                              { className: 'error' }
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Coupon Expiry Date</label>
                      {/* <input
                        type="date"
                        className="form-control"
                        name="coupon_expiry"
                        onChange={handleInputChanges}
                        value={Inputs.coupon_expiry}
                        placeholder="Coupon Expiry Date"
                      /> */}
                      <DatePickerComponent
                        name="coupon_expiry"
                        value={Inputs.coupon_expiry ? new Date(Inputs.coupon_expiry) : null}
                        change={(e) =>
                          handleInputChanges({
                            target: {
                              name: 'coupon_expiry',
                              value: e.value
                            }
                          })
                        }
                        format="dd/MM/yyyy"
                        placeholder="Coupon Expiry Date"
                      />
                      {validator.current.message(
                        'Coupon Expiry Date',
                        Inputs.coupon_expiry,
                        'required',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  {Inputs.discount_type !== 'fixed_product_discount' && (
                    <>
                      {' '}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Minimum Spend
                            <svg
                              data-toggle="tooltip"
                              data-html="true"
                              title="test content"
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#000000d4"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="feather feather-info ml-1 cursor"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="10"
                              ></circle>
                              <line
                                x1="12"
                                y1="16"
                                x2="12"
                                y2="12"
                              ></line>
                              <line
                                x1="12"
                                y1="8"
                                x2="12.01"
                                y2="8"
                              ></line>
                            </svg>
                          </label>
                          <input
                            type="number"
                            min="0"
                            step="1"
                            className="form-control"
                            name="minimum_spend"
                            onChange={handleInputChanges}
                            value={Inputs.minimum_spend}
                            onWheel={(e) => e.currentTarget.blur()}
                            placeholder="Minimum Spend"
                          />
                          {validator.current.message(
                            'minimum_spend',
                            Inputs.minimum_spend,
                            Inputs.discount_type !== 'fixed_product_discount'
                              ? `required|numeric|max:${Inputs.maximum_spend !== null && Inputs.maximum_spend !== '' ? parseInt(Inputs.maximum_spend) - 1 : 0},num`
                              : '',
                            {
                              className: 'error',
                              messages: {
                                max:
                                  Messages.MinimumSpendError +
                                  (Inputs.maximum_spend !== null && Inputs.maximum_spend !== ''
                                    ? Inputs.maximum_spend
                                    : 0)
                              }
                            }
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Maximum Spend</label>
                          <input
                            type="number"
                            min="0"
                            step="1"
                            className="form-control"
                            name="maximum_spend"
                            onChange={handleInputChanges}
                            value={Inputs.maximum_spend}
                            onWheel={(e) => e.currentTarget.blur()}
                            placeholder="Maximum Spend"
                          />
                          {validator.current.message(
                            'maximum_spend',
                            Inputs.maximum_spend,
                            Inputs.discount_type !== 'fixed_product_discount' ? 'required' : '',
                            { className: 'error' }
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {Inputs.discount_type !== 'fixed_cart_discount' && (
                    <div className="col-md-12">
                      <div className="row">
                        <div
                          className={
                            (SelectedCategoryIds !== null && SelectedCategoryIds.length > 0) ||
                            (SelectedExcludeCategoryIds !== null &&
                              SelectedExcludeCategoryIds.length > 0)
                              ? 'col-md-6 d-none'
                              : 'col-md-6'
                          }
                        >
                          <div className="form-group">
                            <label>Products</label>
                            <ReactTags
                              selected={ProductTags}
                              suggestions={Products}
                              onDelete={onDeleteProduct}
                              onAdd={onSelectProduct}
                              onInput={onChangeProduct}
                              placeholderText="Type to search"
                            />
                          </div>
                        </div>
                        <div
                          className={
                            (SelectedCategoryIds !== null && SelectedCategoryIds.length > 0) ||
                            (SelectedExcludeCategoryIds !== null &&
                              SelectedExcludeCategoryIds.length > 0)
                              ? 'col-md-6 d-none'
                              : 'col-md-6'
                          }
                        >
                          <div className="form-group">
                            <label>Exclude Products</label>
                            <ReactTags
                              selected={ExcludeProductTags}
                              suggestions={ExcludeProducts}
                              onDelete={onDeleteExcludeProduct}
                              onAdd={onSelectExcludeProduct}
                              onInput={onChangeExcludeProduct}
                              placeholderText="Type to search"
                            />
                          </div>
                        </div>
                        <div
                          className={
                            (SelectedProductsIds !== null && SelectedProductsIds.length > 0) ||
                            (SelectedExcludeProductsIds !== null &&
                              SelectedExcludeProductsIds.length > 0)
                              ? 'col-md-6 d-none'
                              : 'col-md-6'
                          }
                        >
                          <div className="form-group">
                            <label>Category</label>
                            {Categories.length > 0 && (
                              <DropdownTreeSelect
                                data={Categories}
                                id="categorySelect"
                                mode="hierarchical"
                                onChange={onChangeCategory}
                                className="bootstrap-demo w-100"
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className={
                            (SelectedProductsIds !== null && SelectedProductsIds.length > 0) ||
                            (SelectedExcludeProductsIds !== null &&
                              SelectedExcludeProductsIds.length > 0)
                              ? 'col-md-6 d-none'
                              : 'col-md-6'
                          }
                        >
                          <div className="form-group">
                            <label>Exclude Category</label>
                            {ExcludeCategories.length > 0 && (
                              <DropdownTreeSelect
                                data={ExcludeCategories}
                                id="excludeCategorySelect"
                                mode="hierarchical"
                                onChange={onChangeExcludeCategory}
                                className="bootstrap-demo w-100"
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Allowed Users</label>
                            <ReactTags
                              selected={CustomerTags}
                              suggestions={Customers}
                              onDelete={onDeleteCustomer}
                              onAdd={onSelectCustomer}
                              onInput={onChangeCustomer}
                              placeholderText="Type to search"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Limit Usages to X items</label>
                            <input
                              type="number"
                              min="0"
                              step="1"
                              className="form-control"
                              name="usage_limit_item"
                              value={Inputs.usage_limit_item}
                              onChange={handleInputChanges}
                              onWheel={(e) => e.currentTarget.blur()}
                              placeholder="Unlimited Usages"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Usage Limit per Coupon</label>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="form-control"
                        name="usage_coupon"
                        value={Inputs.usage_coupon}
                        onWheel={(e) => e.currentTarget.blur()}
                        onChange={handleInputChanges}
                        placeholder="Unlimited Usages"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Usage Limit per User</label>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="form-control"
                        name="usage_limit_user"
                        value={Inputs.usage_limit_user}
                        onChange={handleInputChanges}
                        onWheel={(e) => e.currentTarget.blur()}
                        placeholder="Unlimited Usages"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/coupons"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddCoupons
